// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3smbB","label":"CategoryService_label__1MTU_","location":"CategoryService_location__fT33e"};